<template>
  <li class="serp__filter--category q-list-group  q-px-0" v-if="filterData.values.length > 0">
    <div v-for="filter in filterData.values" :key="filter.id">
      <div v-if="filter.label !==''">
        <input class="serp__filter--category-input q-form-check-input q-me-2"
               type="checkbox"
               :value="field"
               @change="updateCategoryItem(field, filter.label)"
               :checked="filtersStore.filterIsChecked(field, filter.label)"
        >
        <FilterLabel :filter="filter"/>
        <SubCategoryItem :filter="filter" :field="field"/>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
import {defineEmits, defineProps} from 'vue';
import SubCategoryItem from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/SubCategoryItem.vue";
import FilterLabel from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/FilterLabel.vue";

defineProps(['filterData', 'field',])

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

const filtersStore = useFiltersStore();


const emit = defineEmits(['closeDropdown']);

function updateCategoryItem(field: string, label:string) {
  filtersStore.updateCategoryItem(field, label)
  emit('closeDropdown');
}


</script>
<style>
input.serp__filter--category-input {
  cursor: pointer!important;
}

.q-form-check-input:focus{
  border-color: none;
  outline: 0;
  box-shadow: none!important;
}
.q-form-check-input{
  width: 1.25em;
  height: 1.25em;
}

.q-form-check-input:checked {
  background-color: var(--q-red);
  border-color: var(--q-red);
}
.serp__filter--category-input{
  text-wrap: nowrap;
}
</style>